import { render } from "./ThePageWrapper.vue?vue&type=template&id=7eba22b8"
import script from "./ThePageWrapper.vue?vue&type=script&lang=js"
export * from "./ThePageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__